import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

type Embalagem = {
  material: string;
  idEmbalagem: number;
};

type Props = {
  embalagens: Embalagem[];
  onSave: (produto: {
    produto: string;
    embalagens: Embalagem[];
  }) => Promise<boolean>;
  onCancel: () => void;
};

const AdicionarProdutos = ({ embalagens, onSave, onCancel }: Props) => {
  const [produto, setProduto] = useState("");
  const [material, setMaterial] = useState("");
  const [idEmbalagem, setIdEmbalagem] = useState<number | "">("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!produto.trim() || !material.trim() || idEmbalagem === "") {
      toast.error("Preencha todos os campos.");
      return;
    }

    setLoading(true);
    try {
      const success = await onSave({
        produto: produto.trim(),
        embalagens: [
          { material: material.trim(), idEmbalagem: Number(idEmbalagem) },
        ],
      });

      if (success) {
        toast.success("Produto criado com sucesso!");
        setProduto("");
        setMaterial("");
        setIdEmbalagem("");
      } else {
        toast.error("Erro ao criar produto.");
      }
    } catch (error) {
      toast.error("Erro inesperado ao criar produto.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Overlay>
      <ModalContainer>
        <Title>Adicionar Produto</Title>

        <InputGroup>
          <Input
            type="text"
            value={produto}
            onChange={(e) => setProduto(e.target.value)}
            placeholder="Nome do Produto"
            disabled={loading}
          />
          <Label>Produto</Label>
        </InputGroup>

        <InputGroup>
          <Select
            value={idEmbalagem}
            onChange={(e) => {
              const selectedId = Number(e.target.value);
              setIdEmbalagem(selectedId);

              const embalagemSelecionada = embalagens.find(
                (emb) => emb.idEmbalagem === selectedId
              );
              setMaterial(embalagemSelecionada?.material || "");
            }}
            disabled={loading}
          >
            <option value="">Selecione uma embalagem</option>
            {embalagens.map((emb) => (
              <option key={emb.idEmbalagem} value={emb.idEmbalagem}>
                {emb.material}
              </option>
            ))}
          </Select>
          <Label>Embalagem</Label>
        </InputGroup>

        <ButtonGroup>
          <ButtonCancelar onClick={onCancel} disabled={loading}>
            Voltar
          </ButtonCancelar>
          <ButtonEnviar onClick={handleSubmit} disabled={loading}>
            {loading ? "Salvando..." : "Enviar"}
          </ButtonEnviar>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
};

export default AdicionarProdutos;
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(20, 25, 41, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background: white;
  width: 400px;
  padding: 30px 28px;
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.14);
`;

const Title = styled.h2`
  font-size: 22px;
  color: #2c3e50;
  margin-bottom: 40px;
  text-align: center;
`;

const InputGroup = styled.div`
  position: relative;
  margin-bottom: 26px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1.8px solid #cfd8dc;
  border-radius: 6px;
  outline: none;

  &:focus {
    border-color: #007bff;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1.8px solid #cfd8dc;
  border-radius: 6px;
  background-color: #fff;
  color: #2c3e50;
  outline: none;
  appearance: none;
  cursor: pointer;

  &:focus {
    border-color: #007bff;
  }
`;

const Label = styled.label`
  position: absolute;
  left: 14px;
  top: -10px;
  background: white;
  padding: 0 6px;
  font-size: 13px;
  color: #607d8b;
  pointer-events: none;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ButtonBase = styled.button`
  flex: 1;
  padding: 12px 0;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s;
  border: none;
  margin: 0 8px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ButtonEnviar = styled(ButtonBase)`
  background-color: rgb(183, 152, 97);
  color: white;

  &:hover:not(:disabled) {
    background-color: rgba(99, 68, 15, 0.747);
  }
`;

const ButtonCancelar = styled(ButtonBase)`
  background-color: #e0e0e0;
  color: #444;

  &:hover:not(:disabled) {
    background-color: #bdbdbd;
  }
`;